// extracted by mini-css-extract-plugin
module.exports = {"alert":"ReLoginOverlay__alert___18qGC"};